import { render } from "./ListaSinistrosView.vue?vue&type=template&id=85e59c8e&scoped=true"
import script from "./ListaSinistrosView.vue?vue&type=script&lang=js"
export * from "./ListaSinistrosView.vue?vue&type=script&lang=js"

import "./ListaSinistrosView.vue?vue&type=style&index=0&id=85e59c8e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85e59c8e"]])

export default __exports__